import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'antd';
import {
  DashboardPageShell,
  DashboardPanel,
  DashboardPrimaryActionButton,
} from './components/dashboard';
import { useAuth } from './auth/AuthProvider';
import './styles/authOnboarding.css';

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();

  return (
    <DashboardPageShell
      title="Sign in"
      productDashboardShell="customer"
      headerClassName="dashboard-fleet-header"
      contentClassName="dashboard-fleet-page auth-onboarding-page auth-login-page"
      contentInnerClassName="auth-onboarding-shell"
      shellClassName="auth-onboarding-page-shell"
    >
      <DashboardPanel className="dashboard-fleet-dashboard-panel auth-onboarding-panel">
        <header className="auth-onboarding-header">
          <p className="auth-onboarding-eyebrow">ManageLift</p>
          <h1 className="auth-onboarding-title">Sign in to ManageLift</h1>
          <p className="auth-onboarding-subtitle">
            Access your fleet, maintenance, and invite workflows through ManageLift’s secure sign-in.
          </p>
        </header>

        <div className="auth-onboarding-content">
          <div className="auth-onboarding-section auth-onboarding-actions">
            <DashboardPrimaryActionButton
              size="large"
              onClick={login}
              className="auth-onboarding-primary"
            >
              Log in
            </DashboardPrimaryActionButton>

            <Button
              size="large"
              onClick={() => navigate('/signup')}
              className="dashboard-secondary-action-button auth-onboarding-secondary"
            >
              Create customer account
            </Button>

            <p className="auth-onboarding-note">
              Technician and operator accounts are invite-only. Use the invite link sent by your customer administrator.
            </p>
          </div>
        </div>
      </DashboardPanel>
    </DashboardPageShell>
  );
}
